import { CapacitorBridge } from './adapters/capacitor';
import { RNWebViewBridge } from './adapters/rnWebView';
import { WebBridge } from './adapters/web';
import type { PlatformBridge } from './PlatformBridge';

export * from './PlatformBridge';
export type { Evt } from './envelope';

declare global {
  interface Window {
    Capacitor?: { getPlatform(): string; isNativePlatform?(): boolean };
  }
}

let instance: PlatformBridge | null = null;

function detect(): PlatformBridge {
  const cap = window.Capacitor;
  if (cap && typeof cap.getPlatform === 'function') {
    const p = cap.getPlatform();
    if (p === 'ios') return new CapacitorBridge('capacitor-ios');
    if (p === 'android') return new CapacitorBridge('capacitor-android');
  }
  if (window.ReactNativeWebView) return new RNWebViewBridge();
  return new WebBridge();
}

/** 앱 부팅 시 한 번 호출. 이후에는 getBridge() 로 꺼내 쓴다. */
export async function initBridge(): Promise<PlatformBridge> {
  if (instance) return instance;
  const b = detect();
  await b.init();
  instance = b;
  return b;
}

export function getBridge(): PlatformBridge {
  if (!instance) throw new Error('initBridge() 를 먼저 호출하세요');
  return instance;
}
